import { v4 as uuid } from "uuid";
export function createIdentificationUniqueId() {
  return uuid();
}
